// couldn't resist with the name

const absolutify = (url: string) =>
    url.match(/^[a-z]*:\/\//i) ? url : `${window.location.origin}${url}`

export default absolutify
